import { useEffect, useState, useRef, useMemo, useCallback } from 'react';
import CustomerMyOrder from './CustomerMyOrder'
import { selectors } from 'redux/CustomerMyOrder';
import { resetOrderRequest } from "client/utils/RequisitionUtil";
import { useDispatch, useSelector } from 'react-redux';
import TotalOrder from '../../../assets/images/MyOrders/My Orders.svg'
import TotalOrderActive from '../../../assets/images/MyOrders/My Orders_Active.svg'
import Submitted from '../../../assets/images/MyOrders/Submitted.svg'
import SubmittedActive from '../../../assets/images/MyOrders/Submitted_Active.svg'
import Approved from '../../../assets/images/MyOrders/Approved.svg'
import ApprovedActive from '../../../assets/images/MyOrders/Approved_Active.svg'
import Completed from '../../../assets/images/MyOrders/Completed.svg'
import CompletedActive from '../../../assets/images/MyOrders/Completed_Active.svg'
import Rejected from '../../../assets/images/MyOrders/Rejected.svg'
import RejectedActive from '../../../assets/images/MyOrders/Rejected_Active.svg'
import Returned from '../../../assets/images/MyOrders/Returned.svg'
import ReturnedActive from '../../../assets/images/MyOrders/Returned_Active.svg'
import Cancelled from '../../../assets/images/Cancelled.svg'
import CancelledActive from '../../../assets/images/Cancelled_Active.svg'
import { setCartNav } from 'redux/MyOrder/action';
import myorderoperations from '../../../../redux/MyOrder/operations'
import { operations } from 'redux/Navigation';
import OrderTypePopup from '../Home/OrdertypePopup';
import { setGrandTotal } from "redux/MyOrder/action";
import userSelectors from 'redux/UserProfile/selectors';
import { useNavigate } from 'react-router-dom';
import RequisitionAction from 'Store/Component/Requisition/RequisitionAction';
import TransferAction from 'Store/Component/Transfer/TransferAction';
import GridFiltersAction from "Store/Component/GridDataFilters/GridDataFiltersAction"
import { CONSTANTS } from '../../../utils/constants'
import { ACTIVE_NAVIGATION } from 'client/utils/constants/activeNavigationConstant';
import { resetAllAssetOrderData } from "client/utils/AssetUtil";
import { getMyOrderGridCount } from 'redux/CustomerMyOrder/actions';
import { getTransferGridCount } from 'Store/Transfer/TransferGrid/TransferGridAction';
import Unsubmitted from "../../../assets/images/DraftMyCart.svg"
import { removeEmptyValues } from 'utils';

const requestSearchByOptions = [
  { value:'orderId',label:'Order#'},
  { value:'assetNo',label:'Asset#'},
  { value:'poNumber',label:'PO#'},
  { value:'vinSerial',label:'VIN/SN'},
  { value:'unitBarcode',label:'Unit/Barcode #'},
];

const assetSearchByOptions = [
  { value:'orderId',label:'Order#'},
  { value:'assetNo',label:'Asset#'},
  { value:'vinSerial',label:'VIN/SN'},
  { value:'unitBarcode',label:'Unit/Barcode #'},
];

const CustomerMyOrderContainer = () => {
  const dispatch = useDispatch();
  const navDispatch = operations.dispatchNav(dispatch);
  const [showMyOrderTypePopup, setShowMyOrderTypePopup] = useState(false)
  const [showModal, setShowModal] = useState(false)
  const [myOrdersearchBoxValue, setmyOrdersearchBoxValue] = useState('')
  const [dateRange, setdateRange] = useState([]);
  const [showGrid, setShowGrid] = useState<boolean>(false)
  const [serverTotal, setServerTotal] = useState(0)
  const [isTabChanged, setIsTabChanged] = useState<any>(false);
  const [globalSearchBy, setGlobalSearchBy] = useState<any>({ value:'orderId',label:'Order#'})

  const hidePopup = () => {
    setShowMyOrderTypePopup(false)
  }
  const dispatchOrderAssetTypes = myorderoperations.dispatchAssestTypes(dispatch)
  const ShowMyOrderPopup = () => {
    setShowMyOrderTypePopup(true)
    dispatchOrderAssetTypes()
  }
  const setModalDisplay = (databool: boolean) => {
    setShowModal(databool);
  }

  const [filteredOrderList, setFilteredOrderList] = useState<any>([])

  const {
    gridData,
    transferGridData,
    gridDataCount,
    transferGridCount,
    branchList,
    assetGridFilters,
    requestGridFilters,
    requestTotalOrderFilters,
    requestSavedOrderFilters,
    requestPendingApprovalFilters,
    requestFleetProcessingGridFilters,
    requestCompletedGridFilters,
    requestRetuernedGridFilters,
    requestPendingFleetGridFilters,
    requestRejectedGridFilters,
    requestCancelledGridFilters,
    assetTotalOrderFilters,
    assetSavedOrderFilters,
    assetPendingApprovalFilters,
    assetFleetProcessingGridFilters,
    assetCompletedGridFilters,
    assetRetuernedGridFilters,
    assetPendingFleetGridFilters,
    assetRejectedGridFilters,
    assetCancelledGridFilters,
    isMyOrdersGridCountsLoading
  }: any = useSelector((state: any) => ({
    gridData: selectors.getMyOrderData(state),
    gridDataCount: state.CustomerMyOrder.myOrderGridCount,
    transferGridData: state.TransferGridReducer.transferGridData,
    transferGridCount: state.TransferGridReducer.transferGridCount,
    branchList: userSelectors.BranchList(state),
    assetGridFilters: state.GridFiltersReducer.assetGridFilters,
    requestGridFilters: state.GridFiltersReducer.requestGridFilters,
    requestTotalOrderFilters: state.GridFiltersReducer.requestTotalOrderGridFilters,
    requestSavedOrderFilters: state.GridFiltersReducer.requestSavedOrderGridFilters,
    requestPendingApprovalFilters : state.GridFiltersReducer.requestPendingApprovalGridFilters,
    requestFleetProcessingGridFilters : state.GridFiltersReducer.requestFleetProcessingGridFilters,
    requestCompletedGridFilters  : state.GridFiltersReducer.requestCompletedGridFilters,
    requestRetuernedGridFilters : state.GridFiltersReducer.requestRetuernedGridFilters,
    requestPendingFleetGridFilters : state.GridFiltersReducer.requestPendingFleetGridFilters,
    requestRejectedGridFilters : state.GridFiltersReducer.requestRejectedGridFilters,
    requestCancelledGridFilters : state.GridFiltersReducer.requestCancelledGridFilters,
    assetTotalOrderFilters: state.GridFiltersReducer.assetTotalOrderGridFilters,
    assetSavedOrderFilters: state.GridFiltersReducer.assetSavedOrderGridFilters,
    assetPendingApprovalFilters : state.GridFiltersReducer.assetPendingApprovalGridFilters,
    assetFleetProcessingGridFilters : state.GridFiltersReducer.assetFleetProcessingGridFilters,
    assetCompletedGridFilters  : state.GridFiltersReducer.assetCompletedGridFilters,
    assetRetuernedGridFilters : state.GridFiltersReducer.assetRetuernedGridFilters,
    assetPendingFleetGridFilters : state.GridFiltersReducer.assetPendingFleetGridFilters,
    assetRejectedGridFilters : state.GridFiltersReducer.assetRejectedGridFilters,
    assetCancelledGridFilters : state.GridFiltersReducer.assetCancelledGridFilters,
    isMyOrdersGridCountsLoading: state.TransferGridReducer.isMyOrdersGridCountsLoading,
  }))

  const regionList = useRef<any>(null);
  const costCenterList = useRef<any>(null);
  const requestedByList = useRef<any>(null);
  const assignedToList = useRef<any>(null);
  const updatedByList = useRef<any>(null);
  const orderStatusList = useRef<any>(null);
  const orderRequestList = useRef<any>(null);
  const fleetItemStatusList = useRef<any>(null);
  const buyerNameList = useRef<any>(null);

  useEffect(() => {
    setShowGrid(true);
  }, [])

  useEffect(() => {
    if (activeNavigation == "Customer My Orders") {
      setFilteredOrderList(gridData?.data)
      setServerTotal(gridData?.totalRecords)
    } else if (activeNavigation == "Asset") {
      setFilteredOrderList(transferGridData?.data)
      setServerTotal(transferGridData?.totalRecords)
    }
  }, [gridData, transferGridData])

  const activeNavigation = useSelector((state: any) => state.nav.nav);

  const breadcrumlist = [
    {
      text: activeNavigation == 'Asset' ? 'Asset' : 'Requests', key: 'f1', href: '/ordermanagement',
      onClick: (e: any) => {
        e.preventDefault();
        dispatch(setGrandTotal(0));
        navDispatch(activeNavigation == 'Asset' ? 'Asset' : 'Customer My Orders')
      }
    },
    {}
  ]

  const orderList = [
    {
      link: activeNavigation == 'Asset' ? transferGridCount?.totalOrders : gridDataCount?.totalOrders,
      text: 'TOTAL ORDER',
      icon: TotalOrder,
      activeIcon: TotalOrderActive,
      icontype: 'totalOrder',
      active: 'active',
      displayText: 'Total Order'
    },
    {
      link: activeNavigation == 'Asset' ? transferGridCount?.submittedOrders : gridDataCount?.submittedOrders,
      subText: 'PENDING APPROVAL',
      icon: Submitted,
      activeIcon: SubmittedActive,
      text: 'SUBMITTED',
      icontype: 'submitted',
      displayText: 'Pending Approval'
    },
    {
      link: activeNavigation == 'Asset' ? transferGridCount?.approvedOrders : gridDataCount?.approvedOrders,
      subText: 'FLEET PROCESSING',
      icon: Approved,
      activeIcon: ApprovedActive,
      text: 'APPROVED',
      icontype: 'approved',
      displayText: 'Fleet Processing'
    },
    {
      link: activeNavigation == 'Asset' ? transferGridCount?.completedOrders : gridDataCount?.completedOrders,
      text: 'COMPLETED',
      icon: CompletedActive,
      activeIcon: Completed,
      subText: 'ASSET IN-SERVICE',
      icontype: 'completed',
      displayText: 'Completed'
    },
    {
      link: activeNavigation == 'Asset' ? transferGridCount?.returnedOrders : gridDataCount?.returnedOrders,
      text: 'RETURNED',
      icon: Returned,
      activeIcon: ReturnedActive,
      subText: 'NEED MORE INFO',
      icontype: 'returned',
      displayText: 'Returned'
    },
    // {
    //   link: activeNavigation == 'Asset' ? transferGridCount?.pendingFleetProcessingOrders : gridDataCount?.pendingFleetProcessingOrders,
    //   icon: Approved,
    //   activeIcon: ApprovedActive,
    //   text: 'PENDING FLEET PROCESSING',
    //   icontype: 'approved',
    //   displayText: 'Pending Fleet Processing'
    // },
    {
      link: activeNavigation == 'Asset' ? transferGridCount?.rejectedOrders : gridDataCount?.rejectedOrders,
      text: 'REJECTED',
      icon: RejectedActive,
      activeIcon: Rejected,
      subText: 'DENIED',
      icontype: 'rejected',
      displayText: 'Rejected'
    },
    {
      link: activeNavigation == 'Asset' ? transferGridCount?.cancelledOrders : gridDataCount?.cancelledOrders,
      text: 'CANCELLED',
      icon: Cancelled,
      activeIcon: CancelledActive,
      subText: 'CANCELLED REQUEST',
      icontype: 'cancelled',
      displayText: 'Cancelled'
    },
    {
      link: activeNavigation == 'Asset' ? transferGridCount?.savedOrders : gridDataCount?.savedOrders,
      text: 'SAVED',
      icon: Unsubmitted,
      activeIcon: Unsubmitted,
      subText: 'DRAFT ORDER',
      icontype: 'saved',
      displayText: 'Saved'
    }
  ]

  const [activeMenu, setactiveMenu] = useState('TotalOrder')

  const searchByOptions = useMemo(() => {
    if (activeNavigation == "Customer My Orders") {
      return requestSearchByOptions
    } else if (activeNavigation == "Asset" &&
      (activeMenu === CONSTANTS.GRID_ACTIVE_MENU.FLEET_PROCESSING ||
        activeMenu === CONSTANTS.GRID_ACTIVE_MENU.PENDING_FLEET_PROCESSING)) {
      return [...assetSearchByOptions, { value: 'buyerName', label: 'Buyer Name' }]
    } else {
      return assetSearchByOptions
    }
  }, [activeNavigation, activeMenu])

  useEffect(() => {
    if (activeNavigation === ACTIVE_NAVIGATION.ASSET) {
      let activeMenuval = assetGridFilters?.activeMenu ?? CONSTANTS.GRID_ACTIVE_MENU.TOTAL_ORDERS
      setactiveMenu(activeMenuval)
      dispatch(getTransferGridCount())
      if (activeMenuval === CONSTANTS.GRID_ACTIVE_MENU.TOTAL_ORDERS) {
        assetTotalOrderFilters.activeMenu = CONSTANTS.GRID_ACTIVE_MENU.TOTAL_ORDERS
        dispatch(GridFiltersAction.setAssetGridFilters(assetTotalOrderFilters))
      } else if (activeMenuval === CONSTANTS.GRID_ACTIVE_MENU.SAVED) {
        assetSavedOrderFilters.activeMenu = CONSTANTS.GRID_ACTIVE_MENU.SAVED
        dispatch(GridFiltersAction.setAssetGridFilters(assetSavedOrderFilters))
      } else if (activeMenuval === CONSTANTS.GRID_ACTIVE_MENU.PENDING_APPROVAL) {
        assetPendingApprovalFilters.activeMenu = CONSTANTS.GRID_ACTIVE_MENU.PENDING_APPROVAL
        dispatch(GridFiltersAction.setAssetGridFilters(assetPendingApprovalFilters))
      } else if (activeMenuval === CONSTANTS.GRID_ACTIVE_MENU.FLEET_PROCESSING) {
        assetFleetProcessingGridFilters.activeMenu = CONSTANTS.GRID_ACTIVE_MENU.FLEET_PROCESSING
        dispatch(GridFiltersAction.setAssetGridFilters(assetFleetProcessingGridFilters))
      } else if (activeMenuval === CONSTANTS.GRID_ACTIVE_MENU.COMPLETED) {
        assetCompletedGridFilters.activeMenu = CONSTANTS.GRID_ACTIVE_MENU.COMPLETED
        dispatch(GridFiltersAction.setAssetGridFilters(assetCompletedGridFilters))
      } else if (activeMenuval === CONSTANTS.GRID_ACTIVE_MENU.RETURNED) {
        assetRetuernedGridFilters.activeMenu = CONSTANTS.GRID_ACTIVE_MENU.RETURNED
        dispatch(GridFiltersAction.setAssetGridFilters(assetRetuernedGridFilters))
      } else if (activeMenuval === CONSTANTS.GRID_ACTIVE_MENU.PENDING_FLEET_PROCESSING) {
        assetPendingFleetGridFilters.activeMenu = CONSTANTS.GRID_ACTIVE_MENU.PENDING_FLEET_PROCESSING
        dispatch(GridFiltersAction.setAssetGridFilters(assetPendingFleetGridFilters))
      } else if (activeMenuval === CONSTANTS.GRID_ACTIVE_MENU.REJECTED) {
        assetRejectedGridFilters.activeMenu = CONSTANTS.GRID_ACTIVE_MENU.REJECTED
        dispatch(GridFiltersAction.setAssetGridFilters(assetRejectedGridFilters))
      } else if (activeMenuval === CONSTANTS.GRID_ACTIVE_MENU.CANCELLED) {
        assetCancelledGridFilters.activeMenu = CONSTANTS.GRID_ACTIVE_MENU.CANCELLED
        dispatch(GridFiltersAction.setAssetGridFilters(assetCancelledGridFilters))
      }
    } else {
      let activeMenuval = requestGridFilters?.activeMenu ?? CONSTANTS.GRID_ACTIVE_MENU.TOTAL_ORDERS
      setactiveMenu(activeMenuval)
      dispatch(getMyOrderGridCount());
      if (activeMenuval === CONSTANTS.GRID_ACTIVE_MENU.TOTAL_ORDERS) {
        requestTotalOrderFilters.activeMenu = CONSTANTS.GRID_ACTIVE_MENU.TOTAL_ORDERS
        dispatch(GridFiltersAction.setRequestGridFilters(requestTotalOrderFilters))
      } else if (activeMenuval === CONSTANTS.GRID_ACTIVE_MENU.SAVED) {
        requestSavedOrderFilters.activeMenu = CONSTANTS.GRID_ACTIVE_MENU.SAVED
        dispatch(GridFiltersAction.setRequestGridFilters(requestSavedOrderFilters))
      } else if (activeMenuval === CONSTANTS.GRID_ACTIVE_MENU.PENDING_APPROVAL) {
        requestPendingApprovalFilters.activeMenu = CONSTANTS.GRID_ACTIVE_MENU.PENDING_APPROVAL
        dispatch(GridFiltersAction.setRequestGridFilters(requestPendingApprovalFilters))
      } else if (activeMenuval === CONSTANTS.GRID_ACTIVE_MENU.FLEET_PROCESSING) {
        requestFleetProcessingGridFilters.activeMenu = CONSTANTS.GRID_ACTIVE_MENU.FLEET_PROCESSING
        dispatch(GridFiltersAction.setRequestGridFilters(requestFleetProcessingGridFilters))
      } else if (activeMenuval === CONSTANTS.GRID_ACTIVE_MENU.COMPLETED) {
        requestCompletedGridFilters.activeMenu = CONSTANTS.GRID_ACTIVE_MENU.COMPLETED
        dispatch(GridFiltersAction.setRequestGridFilters(requestCompletedGridFilters))
      } else if (activeMenuval === CONSTANTS.GRID_ACTIVE_MENU.RETURNED) {
        requestRetuernedGridFilters.activeMenu = CONSTANTS.GRID_ACTIVE_MENU.RETURNED
        dispatch(GridFiltersAction.setRequestGridFilters(requestRetuernedGridFilters))
      } else if (activeMenuval === CONSTANTS.GRID_ACTIVE_MENU.PENDING_FLEET_PROCESSING) {
        requestPendingFleetGridFilters.activeMenu = CONSTANTS.GRID_ACTIVE_MENU.PENDING_FLEET_PROCESSING
        dispatch(GridFiltersAction.setRequestGridFilters(requestPendingFleetGridFilters))
      } else if (activeMenuval === CONSTANTS.GRID_ACTIVE_MENU.REJECTED) {
        requestRejectedGridFilters.activeMenu = CONSTANTS.GRID_ACTIVE_MENU.REJECTED
        dispatch(GridFiltersAction.setRequestGridFilters(requestRejectedGridFilters))
      } else if (activeMenuval === CONSTANTS.GRID_ACTIVE_MENU.CANCELLED) {
        requestCancelledGridFilters.activeMenu = CONSTANTS.GRID_ACTIVE_MENU.CANCELLED
        dispatch(GridFiltersAction.setRequestGridFilters(requestCancelledGridFilters))
      }
    }
  }, [])



  const setActiveMenuData = (activeMenu: any) => {
    if (activeNavigation == "Customer My Orders") {
      if (activeMenu === CONSTANTS.GRID_ACTIVE_MENU.TOTAL_ORDERS) {
        removeEmptyValues(requestTotalOrderFilters, clearFilterValues)
        requestTotalOrderFilters.activeMenu = CONSTANTS.GRID_ACTIVE_MENU.TOTAL_ORDERS
        dispatch(GridFiltersAction.setRequestGridFilters(requestTotalOrderFilters))
      } else if (activeMenu === CONSTANTS.GRID_ACTIVE_MENU.SAVED) {
        removeEmptyValues(requestSavedOrderFilters, clearFilterValues)
        requestSavedOrderFilters.activeMenu = CONSTANTS.GRID_ACTIVE_MENU.SAVED
        dispatch(GridFiltersAction.setRequestGridFilters(requestSavedOrderFilters))
      } else if (activeMenu === CONSTANTS.GRID_ACTIVE_MENU.PENDING_APPROVAL) {
        removeEmptyValues(requestPendingApprovalFilters, clearFilterValues)
        requestPendingApprovalFilters.activeMenu = CONSTANTS.GRID_ACTIVE_MENU.PENDING_APPROVAL
        dispatch(GridFiltersAction.setRequestGridFilters(requestPendingApprovalFilters))
      } else if (activeMenu === CONSTANTS.GRID_ACTIVE_MENU.FLEET_PROCESSING) {
        removeEmptyValues(requestFleetProcessingGridFilters, clearFilterValues)
        requestFleetProcessingGridFilters.activeMenu = CONSTANTS.GRID_ACTIVE_MENU.FLEET_PROCESSING
        dispatch(GridFiltersAction.setRequestGridFilters(requestFleetProcessingGridFilters))
      } else if (activeMenu === CONSTANTS.GRID_ACTIVE_MENU.COMPLETED) {
        removeEmptyValues(requestCompletedGridFilters, clearFilterValues)
        requestCompletedGridFilters.activeMenu = CONSTANTS.GRID_ACTIVE_MENU.COMPLETED
        dispatch(GridFiltersAction.setRequestGridFilters(requestCompletedGridFilters))
      } else if (activeMenu === CONSTANTS.GRID_ACTIVE_MENU.RETURNED) {
        removeEmptyValues(requestRetuernedGridFilters, clearFilterValues)
        requestRetuernedGridFilters.activeMenu = CONSTANTS.GRID_ACTIVE_MENU.RETURNED
        dispatch(GridFiltersAction.setRequestGridFilters(requestRetuernedGridFilters))
      } else if (activeMenu === CONSTANTS.GRID_ACTIVE_MENU.PENDING_FLEET_PROCESSING) {
        removeEmptyValues(requestPendingFleetGridFilters, clearFilterValues)
        requestPendingFleetGridFilters.activeMenu = CONSTANTS.GRID_ACTIVE_MENU.PENDING_FLEET_PROCESSING
        dispatch(GridFiltersAction.setRequestGridFilters(requestPendingFleetGridFilters))
      } else if (activeMenu === CONSTANTS.GRID_ACTIVE_MENU.REJECTED) {
        removeEmptyValues(requestRejectedGridFilters, clearFilterValues)
        requestRejectedGridFilters.activeMenu = CONSTANTS.GRID_ACTIVE_MENU.REJECTED
        dispatch(GridFiltersAction.setRequestGridFilters(requestRejectedGridFilters))
      } else if (activeMenu === CONSTANTS.GRID_ACTIVE_MENU.CANCELLED) {
        removeEmptyValues(requestCancelledGridFilters,clearFilterValues)
        requestCancelledGridFilters.activeMenu = CONSTANTS.GRID_ACTIVE_MENU.CANCELLED
        dispatch(GridFiltersAction.setRequestGridFilters(requestCancelledGridFilters))
      }
    } else if (activeNavigation == "Asset") {
      if (activeMenu === CONSTANTS.GRID_ACTIVE_MENU.TOTAL_ORDERS) {
        removeEmptyValues(assetTotalOrderFilters, clearFilterValues)
        assetTotalOrderFilters.activeMenu = CONSTANTS.GRID_ACTIVE_MENU.TOTAL_ORDERS
        dispatch(GridFiltersAction.setAssetGridFilters(assetTotalOrderFilters))
      } else if (activeMenu === CONSTANTS.GRID_ACTIVE_MENU.SAVED) {
        removeEmptyValues(assetSavedOrderFilters, clearFilterValues)
        assetSavedOrderFilters.activeMenu = CONSTANTS.GRID_ACTIVE_MENU.SAVED
        dispatch(GridFiltersAction.setAssetGridFilters(assetSavedOrderFilters))
      } else if (activeMenu === CONSTANTS.GRID_ACTIVE_MENU.PENDING_APPROVAL) {
        removeEmptyValues(assetPendingApprovalFilters, clearFilterValues)
        assetPendingApprovalFilters.activeMenu = CONSTANTS.GRID_ACTIVE_MENU.PENDING_APPROVAL
        dispatch(GridFiltersAction.setAssetGridFilters(assetPendingApprovalFilters))
      } else if (activeMenu === CONSTANTS.GRID_ACTIVE_MENU.FLEET_PROCESSING) {
        removeEmptyValues(assetFleetProcessingGridFilters, clearFilterValues)
        assetFleetProcessingGridFilters.activeMenu = CONSTANTS.GRID_ACTIVE_MENU.FLEET_PROCESSING
        dispatch(GridFiltersAction.setAssetGridFilters(assetFleetProcessingGridFilters))
      } else if (activeMenu === CONSTANTS.GRID_ACTIVE_MENU.COMPLETED) {
        removeEmptyValues(assetCompletedGridFilters, clearFilterValues)
        assetCompletedGridFilters.activeMenu = CONSTANTS.GRID_ACTIVE_MENU.COMPLETED
        dispatch(GridFiltersAction.setAssetGridFilters(assetCompletedGridFilters))
      } else if (activeMenu === CONSTANTS.GRID_ACTIVE_MENU.RETURNED) {
        removeEmptyValues(assetRetuernedGridFilters, clearFilterValues)
        assetRetuernedGridFilters.activeMenu = CONSTANTS.GRID_ACTIVE_MENU.RETURNED
        dispatch(GridFiltersAction.setAssetGridFilters(assetRetuernedGridFilters))
      } else if (activeMenu === CONSTANTS.GRID_ACTIVE_MENU.PENDING_FLEET_PROCESSING) {
        removeEmptyValues(assetPendingFleetGridFilters, clearFilterValues)
        assetPendingFleetGridFilters.activeMenu = CONSTANTS.GRID_ACTIVE_MENU.PENDING_FLEET_PROCESSING
        dispatch(GridFiltersAction.setAssetGridFilters(assetPendingFleetGridFilters))
      } else if (activeMenu === CONSTANTS.GRID_ACTIVE_MENU.REJECTED) {
        removeEmptyValues(assetRejectedGridFilters, clearFilterValues)
        assetRejectedGridFilters.activeMenu = CONSTANTS.GRID_ACTIVE_MENU.REJECTED
        dispatch(GridFiltersAction.setAssetGridFilters(assetRejectedGridFilters))
      } else if (activeMenu === CONSTANTS.GRID_ACTIVE_MENU.CANCELLED) {
        removeEmptyValues(assetCancelledGridFilters, clearFilterValues)
        assetCancelledGridFilters.activeMenu = CONSTANTS.GRID_ACTIVE_MENU.CANCELLED
        dispatch(GridFiltersAction.setAssetGridFilters(assetCancelledGridFilters))
      }
    }
  }

  useEffect(() => {
    if (isTabChanged) {
      setIsTabChanged(false)
      delete requestGridFilters.orderSearchBoxValue
      delete requestGridFilters.globalSearchField
      delete requestGridFilters.orderId
      delete requestGridFilters.assetNumbers
      delete requestGridFilters.orderPrice
      delete requestGridFilters.frsOrderNumber
      delete requestGridFilters.comment
    }
    if (requestGridFilters?.activeMenu === CONSTANTS.GRID_ACTIVE_MENU.TOTAL_ORDERS) {
      dispatch(GridFiltersAction.setRequestTotalOrderFilters(requestGridFilters))
    } else if (requestGridFilters?.activeMenu === CONSTANTS.GRID_ACTIVE_MENU.PENDING_APPROVAL) {
      dispatch(GridFiltersAction.setRequestPendingApprovalFilters(requestGridFilters))
    } else if (requestGridFilters?.activeMenu === CONSTANTS.GRID_ACTIVE_MENU.FLEET_PROCESSING) {
      dispatch(GridFiltersAction?.setRequestFleetProcessingFilters(requestGridFilters))
    } else if (requestGridFilters?.activeMenu === CONSTANTS.GRID_ACTIVE_MENU.COMPLETED) {
      dispatch(GridFiltersAction?.setRequestCompletedFilters(requestGridFilters))
    } else if (requestGridFilters?.activeMenu === CONSTANTS.GRID_ACTIVE_MENU.RETURNED) {
      dispatch(GridFiltersAction.setRequestReturnedFilters(requestGridFilters))
    } else if (requestGridFilters?.activeMenu === CONSTANTS.GRID_ACTIVE_MENU.PENDING_FLEET_PROCESSING) {
      dispatch(GridFiltersAction.setRequestPendingFleetFilters(requestGridFilters))
    } else if (requestGridFilters?.activeMenu === CONSTANTS.GRID_ACTIVE_MENU.REJECTED) {
      dispatch(GridFiltersAction.setRequestRejectedFilters(requestGridFilters))
    } else if (requestGridFilters?.activeMenu === CONSTANTS.GRID_ACTIVE_MENU.CANCELLED) {
      dispatch(GridFiltersAction.setRequestCancelledFilters(requestGridFilters))
    } else if (requestGridFilters?.activeMenu === CONSTANTS.GRID_ACTIVE_MENU.SAVED) {
      dispatch(GridFiltersAction.setRequestSavedOrderFilters(requestGridFilters))
    }
  }, [requestGridFilters])

  useEffect(() => {
    if (isTabChanged) {
      setIsTabChanged(false)
      delete assetGridFilters.orderSearchBoxValue
      delete assetGridFilters.globalSearchField
      delete assetGridFilters.orderId
      delete assetGridFilters.assetNumbers
      delete assetGridFilters.orderPrice
      delete assetGridFilters.frsOrderNumber
      delete assetGridFilters.comment
    }
    if (assetGridFilters?.activeMenu === CONSTANTS.GRID_ACTIVE_MENU.TOTAL_ORDERS) {
      dispatch(GridFiltersAction.setAssetTotalOrderFilters(assetGridFilters))
    } else if (assetGridFilters?.activeMenu === CONSTANTS.GRID_ACTIVE_MENU.SAVED) {
      dispatch(GridFiltersAction.setAssetSavedOrderFilters(assetGridFilters))
    } else if (assetGridFilters?.activeMenu === CONSTANTS.GRID_ACTIVE_MENU.PENDING_APPROVAL) {
      dispatch(GridFiltersAction.setAssetPendingApprovalFilters(assetGridFilters))
    } else if (assetGridFilters?.activeMenu === CONSTANTS.GRID_ACTIVE_MENU.FLEET_PROCESSING) {
      dispatch(GridFiltersAction?.setAssetFleetProcessingFilters(assetGridFilters))
    } else if (assetGridFilters?.activeMenu === CONSTANTS.GRID_ACTIVE_MENU.COMPLETED) {
      dispatch(GridFiltersAction?.setAssetCompletedFilters(assetGridFilters))
    } else if (assetGridFilters?.activeMenu === CONSTANTS.GRID_ACTIVE_MENU.RETURNED) {
      dispatch(GridFiltersAction.setAssetReturnedFilters(assetGridFilters))
    } else if (assetGridFilters?.activeMenu === CONSTANTS.GRID_ACTIVE_MENU.PENDING_FLEET_PROCESSING) {
      dispatch(GridFiltersAction.setAssetPendingFleetFilters(assetGridFilters))
    } else if (assetGridFilters?.activeMenu === CONSTANTS.GRID_ACTIVE_MENU.REJECTED) {
      dispatch(GridFiltersAction.setAssetRejectedFilters(assetGridFilters))
    } else if (assetGridFilters?.activeMenu === CONSTANTS.GRID_ACTIVE_MENU.CANCELLED) {
      dispatch(GridFiltersAction.setAssetCancelledFilters(assetGridFilters))
    }
  }, [assetGridFilters])

  const handleClick = (item: any) => {
    setIsTabChanged(true)
    setactiveMenu(item)
    setActiveMenuData(item);
    dispatch(setCartNav(''))
    setShowGrid(false);
    setTimeout(() => {
      setShowGrid(true);
    })
  }

  const onSearchOrder = (e: any, isKeyPress?: any) => {
    setmyOrdersearchBoxValue((isKeyPress ? e : e?.target?.value))
    if (activeNavigation === ACTIVE_NAVIGATION.ASSET) {
      dispatch(GridFiltersAction.setAssetGridFilters({ orderSearchBoxValue: (isKeyPress ? e : e?.target?.value), globalSearchField: globalSearchBy }))
    } else {
      dispatch(GridFiltersAction.setRequestGridFilters({ orderSearchBoxValue: (isKeyPress ? e : e?.target?.value), globalSearchField: globalSearchBy }))
    }
  }

  const onDateChange = (e: any) => {
    setdateRange(e);
      if (activeNavigation === ACTIVE_NAVIGATION.ASSET) {
        dispatch(GridFiltersAction.setAssetGridFilters({ dateRange: e }))
      } else {
        dispatch(GridFiltersAction.setRequestGridFilters({ dateRange: e }))
      }
  }

  const clearFilterValues = {
    orderId: '',
    assetNumbers: '',
    status: '',
    orderDate: null,
    regionName: '',
    costCenter: '',
    quantity: '',
    orderRequestType: '',
    requestedBy: '',
    updatedDate: null,
    updatedBy: '',
    assignedTo: '',
    orderPrice: '',
    frsOrderNumber: '',
    comment: '',
    orderSearchBoxValue: '',
    dateRange: [],
    fleetItemStatus: '',
    buyerName: '',
    globalSearchField: null
  }

  const handleFilterClear = () => {
    if (activeNavigation === ACTIVE_NAVIGATION.ASSET) {
      if (assetGridFilters?.activeMenu === CONSTANTS.GRID_ACTIVE_MENU.TOTAL_ORDERS) {
        dispatch(GridFiltersAction.setAssetTotalOrderFilters({}))
     } else if (assetGridFilters?.activeMenu === CONSTANTS.GRID_ACTIVE_MENU.SAVED) {
      dispatch(GridFiltersAction.setAssetSavedOrderFilters({}))
     } else if (assetGridFilters?.activeMenu === CONSTANTS.GRID_ACTIVE_MENU.PENDING_APPROVAL) {
      dispatch(GridFiltersAction.setAssetPendingApprovalFilters({}))
     } else if (assetGridFilters?.activeMenu === CONSTANTS.GRID_ACTIVE_MENU.FLEET_PROCESSING) {
      dispatch(GridFiltersAction.setAssetFleetProcessingFilters({}))
     } else if (assetGridFilters?.activeMenu === CONSTANTS.GRID_ACTIVE_MENU.COMPLETED) {
      dispatch(GridFiltersAction?.setAssetCompletedFilters({}))
     } else if (assetGridFilters?.activeMenu === CONSTANTS.GRID_ACTIVE_MENU.RETURNED) {
      dispatch(GridFiltersAction.setAssetReturnedFilters({}))
     } else if (assetGridFilters?.activeMenu === CONSTANTS.GRID_ACTIVE_MENU.PENDING_FLEET_PROCESSING) {
      dispatch(GridFiltersAction.setAssetPendingFleetFilters({}))
     } else if (assetGridFilters?.activeMenu === CONSTANTS.GRID_ACTIVE_MENU.REJECTED) {
      dispatch(GridFiltersAction.setAssetRejectedFilters({}))
     } else if (assetGridFilters?.activeMenu === CONSTANTS.GRID_ACTIVE_MENU.CANCELLED) {
      dispatch(GridFiltersAction.setAssetCancelledFilters({}))
     }
      dispatch(GridFiltersAction.setAssetGridFilters(clearFilterValues))
    } else {
      if (requestGridFilters?.activeMenu === CONSTANTS.GRID_ACTIVE_MENU.TOTAL_ORDERS) {
        dispatch(GridFiltersAction.setRequestTotalOrderFilters({}))
     } else if (requestGridFilters?.activeMenu === CONSTANTS.GRID_ACTIVE_MENU.PENDING_APPROVAL) {
      dispatch(GridFiltersAction.setRequestPendingApprovalFilters({}))
     } else if (requestGridFilters?.activeMenu === CONSTANTS.GRID_ACTIVE_MENU.FLEET_PROCESSING) {
      dispatch(GridFiltersAction.setRequestFleetProcessingFilters({}))
     } else if (requestGridFilters?.activeMenu === CONSTANTS.GRID_ACTIVE_MENU.COMPLETED) {
      dispatch(GridFiltersAction?.setRequestCompletedFilters({}))
     } else if (requestGridFilters?.activeMenu === CONSTANTS.GRID_ACTIVE_MENU.RETURNED) {
      dispatch(GridFiltersAction.setRequestReturnedFilters({}))
     } else if (requestGridFilters?.activeMenu === CONSTANTS.GRID_ACTIVE_MENU.PENDING_FLEET_PROCESSING) {
      dispatch(GridFiltersAction.setRequestPendingFleetFilters({}))
     } else if (requestGridFilters?.activeMenu === CONSTANTS.GRID_ACTIVE_MENU.REJECTED) {
      dispatch(GridFiltersAction.setRequestRejectedFilters({}))
     } else if (requestGridFilters?.activeMenu === CONSTANTS.GRID_ACTIVE_MENU.CANCELLED) {
      dispatch(GridFiltersAction.setRequestCancelledFilters({}))
     } else if (requestGridFilters?.activeMenu === CONSTANTS.GRID_ACTIVE_MENU.SAVED) {
      dispatch(GridFiltersAction.setRequestSavedOrderFilters({}))
     }
      dispatch(GridFiltersAction.setRequestGridFilters(clearFilterValues))
    }
    setmyOrdersearchBoxValue('');
    setGlobalSearchBy({ value:'orderId',label:'Order#'})
    setdateRange([]);
    // setActiveMenuData(activeMenu);
    setShowGrid(false);
    setTimeout(() => {
      setShowGrid(true);
    })
  }

  useEffect(() => {
    if (activeNavigation === ACTIVE_NAVIGATION.ASSET) {
      if (assetGridFilters?.dateRange?.length) {
        setdateRange(assetGridFilters?.dateRange)
      } else {
        setdateRange([]);
      }
    } else if (activeNavigation === ACTIVE_NAVIGATION.CUSTOMER_MY_ORDERS) {
      if (requestGridFilters?.dateRange?.length) {
        setdateRange(requestGridFilters?.dateRange)
      } else {
        setdateRange([]);
      }
    }
    // setActiveMenuData();
  }, [activeMenu, JSON.stringify(gridData), JSON.stringify(transferGridData)])

  useEffect(() => {
    if (activeNavigation === ACTIVE_NAVIGATION.ASSET) {
      setmyOrdersearchBoxValue(assetGridFilters?.orderSearchBoxValue || '');
      setGlobalSearchBy(assetGridFilters?.globalSearchField ?? { value: 'orderId', label: 'Order#' })
    } else {
      setmyOrdersearchBoxValue(requestGridFilters?.orderSearchBoxValue || '');
      setGlobalSearchBy(requestGridFilters?.globalSearchField ?? { value: 'orderId', label: 'Order#' })
    }
  }, [activeMenu])

  const ActiveTabView = () => {
    switch (activeNavigation) {
      case "Asset":
      // return <RequestTypePopup/>
      case "My Orders":
        return <OrderTypePopup setShowPopup={setModalDisplay} />
      default: break
    }
  }

  const navigate = useNavigate();
  const CreateNewRequisitionHandleClick = () => {
    dispatch(RequisitionAction.setIsEditRequestClick(false))
    dispatch(RequisitionAction.setEditRequestDetails({}))
    dispatch(RequisitionAction.setIsAddAssetclick(false))
    if (activeNavigation == 'Customer My Orders') {
      resetOrderRequest(dispatch);
      dispatch(RequisitionAction.setIsEditOrder(false))
      navigate('/ordermanagement/createorder')
      resetOrderRequest(dispatch);
      dispatch(RequisitionAction.setIsChangesOccured(false))
      dispatch(TransferAction.setIsChangesOccuredInCart(false))
    }
    else if (activeNavigation == 'Asset') {
      dispatch(TransferAction.setTransferOrderDetails({}));
      resetAllAssetOrderData(dispatch)
      dispatch(TransferAction.setIsEditOrder(false));
      navigate('/ordermanagement/assetcreateorder')
      dispatch(RequisitionAction.setIsChangesOccured(false))
      dispatch(TransferAction.setIsChangesOccuredInCart(false))
    }

  }

  const onGlobalSearchByChange = (value: any) => {
    setGlobalSearchBy(value)
    if (activeNavigation === ACTIVE_NAVIGATION.ASSET) {
      dispatch(GridFiltersAction.setAssetGridFilters({ globalSearchField: value }))
    } else {
      dispatch(GridFiltersAction.setRequestGridFilters({ globalSearchField: value }))
    }
  }

  const alreadyHasGridFilterValues = useCallback(() => {
    let isAlreadyHasValues = true
    let GridFilterValueTemp = activeNavigation === ACTIVE_NAVIGATION.ASSET ? assetGridFilters : requestGridFilters
    Object.keys(clearFilterValues)?.forEach((filterItem?: any) => {
      Object.keys(GridFilterValueTemp ?? {})?.forEach((gridItem?: any) => {
        if (filterItem == gridItem) {
          let val = gridItem
          if (GridFilterValueTemp[val] != "" && GridFilterValueTemp[val] != null && GridFilterValueTemp[val] != undefined && val != "dateRange" && val != "globalSearchField") {
            isAlreadyHasValues = false
          } else if (val == "dateRange") {
            if (GridFilterValueTemp[val]?.length) {
              isAlreadyHasValues = false
            }
          }
        }
      })
    })
    return isAlreadyHasValues
  }, [assetGridFilters, requestGridFilters])

  return <CustomerMyOrder data={filteredOrderList}
    breadcrumlist={breadcrumlist}
    orderList={orderList}
    handleClick={handleClick}
    activeMenu={activeMenu}
    showMyOrderTypePopup={showMyOrderTypePopup}
    hidePopup={hidePopup}
    ShowMyOrderPopup={ShowMyOrderPopup}
    setModalDisplay={setModalDisplay}
    showModal={showModal}
    onDateChange={onDateChange}
    branchList={branchList}
    onSearchOrder={onSearchOrder}
    myOrdersearchBoxValue={myOrdersearchBoxValue}
    dateRange={dateRange}
    ActiveTabView={ActiveTabView}
    showGrid={showGrid}
    handleFilterClear={handleFilterClear}
    CreateNewRequisitionHandleClick={CreateNewRequisitionHandleClick}
    assetGridFilters={assetGridFilters}
    requestGridFilters={requestGridFilters}
    serverTotal={serverTotal}
    costCenterList = {costCenterList}
    updatedByList = {updatedByList}
    assignedToList = {assignedToList}
    requestedByList = {requestedByList}
    regionList = {regionList}
    orderStatusList = {orderStatusList}
    orderRequestList = {orderRequestList}
    fleetItemStatusList = {fleetItemStatusList}
    buyerNameList = {buyerNameList}
    isMyOrdersGridCountsLoading={isMyOrdersGridCountsLoading}
    searchByOptions={searchByOptions}
    globalSearchBy={globalSearchBy}
    onGlobalSearchByChange={onGlobalSearchByChange}
    alreadyHasGridFilterValues = {alreadyHasGridFilterValues}
  />
}

export default CustomerMyOrderContainer;